import { render, staticRenderFns } from "./defAdsMonitoring.vue?vue&type=template&id=388211e4&scoped=true"
import script from "./defAdsMonitoring.vue?vue&type=script&lang=js"
export * from "./defAdsMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388211e4",
  null
  
)

export default component.exports